/* Generated from Module-Shop-DTC-HP-Classique-Desktop.html. */
window.NuoroModules=window.NuoroModules||{};
window.NuoroModules["shop"]=function(root){
const document=window.NuoroModuleDocument(root);

(function(){
  /* ── Gallery ── */
  var images = [
      {src:window.NuoroAsset("assets/shop-offers/tropical-sub-1-titre-pastille.png"), alt:"NUORO Tropical", flavor:"tropical"},
      {src:window.NuoroAsset("assets/nuoro-gallery-v2-02.jpg"), alt:"Tout-en-un : 200+ bienfaits, 71 ingrédients, 1 stick par jour"},
      {src:"https://cdn.shopify.com/s/files/1/0811/8229/4348/files/nuoro-bienfaits-source-17-oct.png?v=1792219508&format=pjpg", alt:"Des bienfaits documentés"},
      {src:window.NuoroAsset("assets/nuoro-gallery-v2-04.jpg"), alt:"Tous vos nutriments essentiels dans un seul stick"},
      {src:window.NuoroAsset("assets/nuoro-gallery-v2-06.jpg"), alt:"Visuel produit NUORO 6"},
      {src:"https://cdn.shopify.com/s/files/1/0811/8229/4348/files/nuoro-3-saveurs-fruitees-17-oct.png?v=1792219047&format=pjpg", alt:"Les 3 saveurs NUORO"},
      {src:window.NuoroAsset("assets/nuoro-gallery-v2-08.jpg"), alt:"Visuel produit NUORO 8"},
      {src:window.NuoroAsset("assets/nuoro-gallery-v2-09.jpg"), alt:"Visuel produit NUORO 9"},
      {src:"https://drinknuoro.com/cdn/shop/files/div_post_9_335Ko.jpg?v=1786608025&width=1200", alt:"Visuel produit NUORO 10"},
      {src:window.NuoroAsset("assets/nuoro-gallery-v2-11.jpg"), alt:"Visuel produit NUORO 11"},
      {src:"https://drinknuoro.com/cdn/shop/files/div_post_4_237Ko.jpg?v=1786608025&width=1200", alt:"Visuel produit NUORO 12"},
      {src:window.NuoroAsset("assets/nuoro-gallery-v2-13.jpg"), alt:"Visuel produit NUORO 13"}
  ];
  var R = window.__resources || {};
  /* sources fixées sur le site */
  var galImg = document.getElementById("galImg");
  var thumbsEl = document.getElementById("thumbs");
  var cur = 0;
  images.forEach(function(im, i){
    var b = document.createElement("button");
    b.className = "thumb" + (i===0?" active":"");
    var thumbnail = document.createElement('img'); thumbnail.alt = im.alt; thumbnail.loading = 'lazy';
    window.NuoroResponsiveImage(thumbnail, im.src, '64px', [64,128,192]); b.appendChild(thumbnail);
    b.addEventListener("click", function(){ setImg(i); });
    thumbsEl.appendChild(b);
  });
  var thumbScroll=document.querySelector('.thumb-scroll');
  if(thumbScroll){
    function updateThumbScroll(){var end=thumbsEl.scrollTop+thumbsEl.clientHeight>=thumbsEl.scrollHeight-2;thumbScroll.classList.toggle('at-end',end);thumbScroll.setAttribute('aria-label',end?'Revenir aux premières miniatures':'Voir les miniatures suivantes');thumbScroll.hidden=thumbsEl.scrollHeight<=thumbsEl.clientHeight+2;}
    thumbScroll.addEventListener('click',function(){var end=thumbsEl.scrollTop+thumbsEl.clientHeight>=thumbsEl.scrollHeight-2;thumbsEl.scrollTo({top:end?0:thumbsEl.scrollTop+148,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});});
    thumbsEl.addEventListener('scroll',updateThumbScroll);new ResizeObserver(updateThumbScroll).observe(thumbsEl);
  }
  var mobileGallery = document.createElement("div");
  mobileGallery.className = "gal-touch";
  mobileGallery.tabIndex = 0;
  mobileGallery.setAttribute("role", "region");
  mobileGallery.setAttribute("aria-label", "Photos produit, faites glisser");
  images.forEach(function(im, i){
    var slide = document.createElement("img");
    window.NuoroResponsiveImage(slide, im.src); slide.alt = im.alt; slide.draggable = false;
    slide.loading = "lazy";
    mobileGallery.appendChild(slide);
  });
  galImg.parentElement.appendChild(mobileGallery);
  var galleryMobile = matchMedia("(max-width:767px)");
  function highlightThumb(){
    Array.prototype.forEach.call(thumbsEl.children, function(t,k){t.classList.toggle("active", k===cur);});
  }
  mobileGallery.addEventListener("scroll", function(){
    if(!galleryMobile.matches || !mobileGallery.clientWidth) return;
    cur = Math.round(mobileGallery.scrollLeft / mobileGallery.clientWidth);
    highlightThumb();
    window.NuoroResponsiveImage(galImg, images[cur].src, "(max-width:767px) calc(100vw - 32px), 48vw"); galImg.alt = images[cur].alt;
  }, {passive:true});
  mobileGallery.addEventListener("keydown", function(event){
    if(event.key === "ArrowRight" || event.key === "ArrowLeft"){
      event.preventDefault(); setImg(cur + (event.key === "ArrowRight" ? 1 : -1));
    }
  });
  new ResizeObserver(function(){
    if(galleryMobile.matches) mobileGallery.scrollTo({left:cur*mobileGallery.clientWidth,behavior:"instant"});
  }).observe(mobileGallery);
  function setImg(i){
    cur = (i + images.length) % images.length;
    window.NuoroResponsiveImage(mobileGallery.children[0], images[0].src);
    mobileGallery.children[0].alt = images[0].alt;
    if(galleryMobile.matches){
      clearTimeout(setImg.timer);
      window.NuoroResponsiveImage(galImg, images[cur].src, "(max-width:767px) calc(100vw - 32px), 48vw"); galImg.alt = images[cur].alt; galImg.style.opacity = 1;
      mobileGallery.scrollTo({left:cur*mobileGallery.clientWidth,behavior:matchMedia("(prefers-reduced-motion:reduce)").matches ? "instant" : "smooth"});
      highlightThumb();
      return;
    }
    galImg.style.opacity = 0;
    clearTimeout(setImg.timer);
    setImg.timer = setTimeout(function(){ window.NuoroResponsiveImage(galImg, images[cur].src, "(max-width:767px) calc(100vw - 32px), 48vw"); galImg.alt = images[cur].alt; galImg.style.opacity = 1; }, 130);
    Array.prototype.forEach.call(thumbsEl.children, function(t, k){ t.classList.toggle("active", k===cur); });
  }
  galImg.setAttribute("role", "button");
  galImg.setAttribute("tabindex", "0");
  galImg.setAttribute("aria-label", "Afficher la photo produit suivante");
  galImg.style.cursor = "pointer";
  var galleryGesture = null, suppressGalleryClickUntil = 0;
  galImg.style.touchAction = "pan-y pinch-zoom";
  galImg.draggable = false;
  galImg.addEventListener("pointerdown", function(event){
    if(!event.isPrimary){ galleryGesture = null; return; }
    if(event.button !== 0) return;
    galleryGesture = {id:event.pointerId, x:event.clientX, y:event.clientY};
    galImg.setPointerCapture(event.pointerId);
  });
  galImg.addEventListener("pointerup", function(event){
    if(!galleryGesture || galleryGesture.id !== event.pointerId) return;
    var dx = event.clientX-galleryGesture.x, dy = event.clientY-galleryGesture.y;
    galleryGesture = null;
    if(Math.abs(dx)>10 || Math.abs(dy)>10) suppressGalleryClickUntil = Date.now()+700;
    if(Math.abs(dx)>=40 && Math.abs(dx)>Math.abs(dy)*1.25) setImg(cur+(dx<0?1:-1));
  });
  function cancelGalleryGesture(){
    galleryGesture = null;
    suppressGalleryClickUntil = Date.now()+700;
  }
  galImg.addEventListener("pointercancel", cancelGalleryGesture);
  galImg.addEventListener("lostpointercapture", function(){ galleryGesture = null; });
  galImg.addEventListener("click", function(event){
    if(Date.now()<suppressGalleryClickUntil){ event.preventDefault(); return; }
    setImg(cur+1);
  });
  galImg.addEventListener("keydown", function(event){
    if(event.key === "Enter" || event.key === " " || event.key === "ArrowRight"){
      event.preventDefault(); setImg(cur+1);
    } else if(event.key === "ArrowLeft"){
      event.preventDefault(); setImg(cur-1);
    }
  });
  document.getElementById("galPrev").addEventListener("click", function(){ setImg(cur-1); });
  document.getElementById("galNext").addEventListener("click", function(){ setImg(cur+1); });

  /* ── Sticky gallery when embedded (host posts nuoroViewTop) ── */
  (function(){
    var left = document.querySelector(".col-left"), pdp = document.querySelector(".pdp"); if(!left || !pdp) return;
    var TOP = 92, lastViewTop = 0; // sous la nav sticky du site
    function apply(viewTop){
      lastViewTop = viewTop;
      if(window.innerWidth < 980){ left.style.transform = ""; return; }
      var pr = pdp.getBoundingClientRect(), lr = left.getBoundingClientRect();
      var pdpTop = pr.top + window.scrollY, pdpBottom = pr.bottom + window.scrollY;
      var leftH = left.offsetHeight;
      var pdpStyle = getComputedStyle(pdp);
      var leftTop = pdpTop + parseFloat(pdpStyle.paddingTop);
      var y = viewTop + TOP - leftTop;
      // Stop the entire gallery, including captions, inside the padded grid.
      var max = pdpBottom - parseFloat(pdpStyle.paddingBottom) - leftTop - leftH;
      y = Math.max(0, Math.min(y, max));
      left.style.transform = y > 0 ? "translateY(" + y + "px)" : "";
    }
    var embedded = window.parent !== window;
    if(!embedded){
      var gallery = left.querySelector(".gallery");
      function fitStickyGallery(){
        var main = gallery.querySelector(".gal-main");
        if(window.innerWidth < 1024){
          main.style.maxWidth = "";
          main.style.marginInline = "";
          left.style.top = window.innerWidth < 980 ? "" : "31px";
          return;
        }
        var extraHeight = gallery.offsetHeight - main.offsetHeight;
        var available = Math.max(1, window.innerHeight - 31 - 16 - extraHeight);
        main.style.maxWidth = Math.floor(available) + "px";
        main.style.marginInline = "auto";
        left.style.top = "31px";
      }
      new ResizeObserver(fitStickyGallery).observe(gallery);
      window.addEventListener("resize", fitStickyGallery);
      fitStickyGallery();
    }
    if(embedded){
      left.style.position = "relative"; left.style.top = "auto"; left.style.willChange = "transform";
      var galleryResize = new ResizeObserver(function(){ apply(lastViewTop); });
      galleryResize.observe(left); galleryResize.observe(pdp);
      window.addEventListener("message", function(e){ if(e.data && typeof e.data.nuoroViewTop === "number") apply(e.data.nuoroViewTop); });
    }
  })();

  /* ── Pricing model ── */
  var state = { flavor:"tropical", qty:1, freq:"sub" };
  var offerParams = new URLSearchParams(location.search);
  var offerStyle = "titre-pastille";
  if(["simple","titre","pastille","titre-pastille"].indexOf(offerStyle)<0) offerStyle="titre-pastille";
  function giftEuro(n){ return String(n).replace(".",",")+"€"; }
  function updateOfferPhoto(){
    var names={tropical:"Tropical",rouges:"Fruits rouges",agrumes:"Agrumes"};
    images[0].src=window.NuoroAsset("assets/shop-offers/"+state.flavor+"-"+state.freq+"-"+state.qty+"-"+offerStyle+".png");
    images[0].alt="NUORO "+names[state.flavor]+" · "+(state.qty===2?"Duo, 2 boîtes":"Single, 1 boîte")+" · "+(state.freq==="sub"?"Abonnement":"Achat unique")+" · "+giftEuro((state.freq==="sub"?22.5:15)*state.qty)+" de cadeaux offerts";
    if(thumbsEl.children[0]){ var thumb=thumbsEl.children[0].querySelector("img"); window.NuoroResponsiveImage(thumb,images[0].src,"64px",[64,128,192]); thumb.alt=images[0].alt; }
    setImg(0);
  }
  var COMPARE = window.NuoroCommerce.pricing(state).compare;       // prix barré unitaire
  var PLANS = { sub:{unit:0, boxes:1}, once:{unit:0, boxes:1} };

  function eur(n){ return n.toFixed(2).replace(".", ",") + "€"; }
  function eurDaily(n){ return (Math.floor(n * 100) / 100).toFixed(2).replace(".", ",") + "€"; }
  function eurDec(n){ var s=eurNice(n); var m=s.match(/^(\d+)(,\d+)?€$/); return m?(m[1]+'<span class="dec">'+(m[2]||'')+'€</span>'):s; }
  function eurNice(n){ var s = n.toFixed(2).replace(/\.00$/, ""); return s.replace(".", ",") + "€"; }

  function recompute(){
    var live = window.NuoroCommerce.pricing(state);
    COMPARE=live.compare; PLANS.sub.unit=live.subscription; PLANS.once.unit=live.once;
    document.querySelectorAll("#flavors .flavor").forEach(function(button){var offer=window.NuoroCommerce.pricing(Object.assign({},state,{flavor:button.dataset.flavor}));button.disabled=!offer.variant||!offer.variant.available;button.setAttribute("aria-disabled",String(button.disabled));});
    document.querySelectorAll("#atc,[data-atc-mirror]").forEach(function(button){button.disabled=!live.variant||!live.variant.available||(state.freq==="sub"&&!live.plan);});
    updateFlavorDescription();
    var p = PLANS[state.freq];
    var qtyMult = live.quantityMultiplier;     // −5% pour 2 personnes
    var CODE = 1;   // RENTREE10 : −10% sur la 1re commande abo
    var total = p.unit * p.boxes * state.qty * qtyMult * CODE;
    var compare = COMPARE * p.boxes * state.qty;
    var savings = compare - total;
    var SHIP = 4.90; var KIT = 22.5;
    var adv = (PLANS.once.unit - PLANS.sub.unit) * state.qty * qtyMult + KIT;
    var best = document.querySelector('.freq.best'); if(best) best.setAttribute('data-adv', eurNice(Math.round(adv*100)/100));
    set("[data-perk-save]", eurNice(Math.round((COMPARE - PLANS.sub.unit*qtyMult) * state.qty*100)/100) + " d’économies à chaque commande");

    set("[data-was-sub]", eurNice(COMPARE));
    set("[data-now-sub]", eurNice(PLANS.sub.unit*state.qty*qtyMult));
    set("[data-badge-sub]", "−" + Math.floor((1 - PLANS.sub.unit*qtyMult/COMPARE)*100+1e-9) + "%");
    set("[data-fsub-boxes]", "Tous les 30 jours");
    document.querySelectorAll("[data-code-sub]").forEach(function(el){ el.innerHTML = eurDec(Math.round(PLANS.sub.unit*qtyMult*100)/100); });
    set("[data-perday-sub]", eurDaily((PLANS.sub.unit*qtyMult)/30) + "/jour");

    set("[data-was-once]", eurNice(COMPARE));
    document.querySelectorAll("[data-now-once]").forEach(function(el){ el.innerHTML = eurDec(PLANS.once.unit*qtyMult); });

    set("[data-was-cta]", eurNice(compare));
    set("[data-now-cta]", eurNice(total));
    set("[data-was-sticky]", eurNice(compare));
    set("[data-now-sticky]", eurNice(total));
    set("[data-econ]", "Vous économisez " + eurNice(state.freq === "once" ? Math.round(savings*100)/100 : Math.round(adv*100)/100));
    document.querySelectorAll("[data-was-cta],[data-was-sticky]").forEach(function(el){ el.style.display = savings > 0.001 ? "" : "none"; });
    document.querySelectorAll("[data-econ]").forEach(function(el){ el.style.display = savings > 0.001 ? "" : "none"; });

    set("[data-gift-val]", giftEuro(22.5*state.qty));
    set("[data-gift-val-once]", giftEuro(15*state.qty));
    set("[data-shaker-count]", state.qty + (state.qty===2 ? " Shakers NUORO" : " Shaker NUORO"));
    set("[data-shaker-value]", giftEuro(15*state.qty));
    set("[data-stick-count]", (2*state.qty) + " Sticks découverte");
    set("[data-stick-value]", giftEuro(7.5*state.qty));
    updateOfferPhoto();
    document.querySelectorAll("#freqs .freq").forEach(function(f){ f.classList.toggle("active", f.dataset.freq === state.freq); });
  }
  function set(sel, txt){ document.querySelectorAll(sel).forEach(function(el){ el.textContent = txt; }); }

  /* ── Flavor ── */
  function updateFlavorDescription(){
    var descriptions = {
      tropical: "L'originale. Fruitée et légère",
      rouges: "Fruitée et douce",
      agrumes: "Vive et ensoleillée"
    };
    set("#flavor-description", descriptions[state.flavor]);
  }
  document.getElementById("flavors").addEventListener("click", function(e){
    var b = e.target.closest(".flavor"); if(!b || b.disabled) return;
    this.querySelectorAll(".flavor").forEach(function(f){ f.classList.remove("active"); });
    b.classList.add("active"); state.flavor = b.dataset.flavor;
    recompute();
  });

  /* Delivery: noon Paris, preparation Monday-Saturday incl. Pentecost; two delivery days. */
  (function(){
/* Calendar-only dates are stored at UTC midnight to avoid DST arithmetic errors. */
function calculateDelivery(now, options) {
  var parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', hourCycle: 'h23'
  }).formatToParts(now);
  var paris = {};
  parts.forEach(function (part) { paris[part.type] = part.value; });
  var date = new Date(Date.UTC(+paris.year, +paris.month - 1, +paris.day));
  function advance(d, days) { d.setUTCDate(d.getUTCDate() + days); return d; }
  function easter(year) {
    var a=year%19, b=Math.floor(year/100), c=year%100, d=Math.floor(b/4), e=b%4;
    var f=Math.floor((b+8)/25), g=Math.floor((b-f+1)/3), h=(19*a+b-d-g+15)%30;
    var i=Math.floor(c/4), k=c%4, l=(32+2*e+2*i-h-k)%7, m=Math.floor((a+11*h+22*l)/451);
    var n=h+l-7*m+114;
    return new Date(Date.UTC(year, Math.floor(n/31)-1, n%31+1));
  }
  function holiday(d) {
    var key=(d.getUTCMonth()+1)+'-'+d.getUTCDate();
    if (['1-1','5-1','5-8','7-14','8-15','11-1','11-11','12-25'].indexOf(key)!==-1) return 'fixed';
    var days=Math.round((d-easter(d.getUTCFullYear()))/86400000);
    return days===1?'easterMonday':days===39?'ascension':days===50?'pentecost':null;
  }
  function preparationDay(d) {
    var day=d.getUTCDay(), h=holiday(d);
    return day!==0 && (day!==6 || options.prepareSaturday) && (!h || (h==='pentecost' && options.preparePentecost));
  }
  if (+paris.hour >= 12) advance(date,1);
  while (!preparationDay(date)) advance(date,1);
  var dispatched = new Date(date);
  for(var transit=0;transit<2;) {
    advance(date,1);
    if(date.getUTCDay()!==0 && !holiday(date)) transit++;
  }
  return {dispatch:dispatched, delivery:date};
}

    var el = document.querySelector(".delivery .when b"); if (!el) return;
    function refreshDelivery(){
      var d = calculateDelivery(new Date(), {prepareSaturday:true, preparePentecost:true}).delivery;
      el.textContent = d.toLocaleDateString("fr-FR",{timeZone:"UTC",weekday:"short",day:"numeric",month:"short"});
      el.title = d.toLocaleDateString("fr-FR",{timeZone:"UTC",weekday:"long",day:"numeric",month:"long"});
    }
    refreshDelivery();
    var deliveryTimer = window.setInterval(function(){
      if (!el.isConnected) { window.clearInterval(deliveryTimer); return; }
      refreshDelivery();
    }, 30000);
  })();

  /* ── Quantity ── */
  document.getElementById("qty").addEventListener("click", function(e){
    var b = e.target.closest(".qty-opt"); if(!b) return;
    this.querySelectorAll(".qty-opt").forEach(function(f){ f.classList.remove("active"); });
    b.classList.add("active"); state.qty = parseInt(b.dataset.qty,10); recompute();
  });

  /* ── Frequency ── */
  document.getElementById("freqs").addEventListener("click", function(e){
    var b = e.target.closest(".freq"); if(!b) return;
    state.freq = b.dataset.freq; recompute();
  });

  /* ── Accordions ── */
  document.querySelectorAll("#acc .acc-head").forEach(function(h){
    h.addEventListener("click", function(){
      var item = h.parentElement;
      var body = item.querySelector(".acc-body");
      var open = item.classList.toggle("open");
      body.style.maxHeight = open ? body.scrollHeight + "px" : 0;
    });
  });

  /* ── Add to cart toast ── */
  function openCart(){ return window.NuoroCommerce.add({qty:state.qty,sub:state.freq==="sub",flavor:state.flavor},root); }
  document.getElementById("atc").addEventListener("click", openCart);
  document.querySelectorAll("[data-atc-mirror]").forEach(function(b){ b.addEventListener("click", openCart); });

  /* ── URL state (?acc=open · ?freq=once) ── */
  var params = new URLSearchParams(location.search);
  if(params.get("acc") === "open"){
    document.querySelectorAll("#acc .acc-item").forEach(function(item){
      item.classList.add("open");
      item.querySelector(".acc-body").style.maxHeight = "none";
    });
  }
  if(params.get("freq") === "once"){ state.freq = "once"; }
  if(params.get("freq") === "sub"){ state.freq = "sub"; }

  if(["tropical","rouges","agrumes"].indexOf(params.get("flavor"))>=0) state.flavor=params.get("flavor");
  if(params.get("qty")==="2") state.qty=2;
  document.querySelectorAll("#flavors .flavor").forEach(function(el){el.classList.toggle("active",el.dataset.flavor===state.flavor)});
  document.querySelectorAll("#qty .qty-opt").forEach(function(el){el.classList.toggle("active",Number(el.dataset.qty)===state.qty)});
  recompute();
})();

(function(){
 const d=document, mobile=matchMedia('(max-width:1023px)').matches, module=d.body.dataset.nuoroModule;
 // Mobile navigation is added around the existing desktop links, without a second header source.
 const desktopNav=d.querySelector('.hero>.nav');
 if(mobile&&desktopNav&&!desktopNav.querySelector('.nuoro-mobile-toggle')){
  const toggle=d.createElement('button');toggle.className='nuoro-mobile-toggle';toggle.type='button';toggle.setAttribute('aria-label','Ouvrir le menu');toggle.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h16"/></svg>';
  desktopNav.prepend(toggle);toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-haspopup','dialog');toggle.onclick=()=>window.NuoroNavigation.openMenu(root);
 }
 if(module==='Fondateurs')d.querySelectorAll('a.cta').forEach(a=>{a.href='/pages/mission';a.addEventListener('click',e=>{e.preventDefault();window.location.href=a.href})});
 if(module==='Avis')d.querySelectorAll('.lnk').forEach(a=>{a.href='https://fr.trustpilot.com/review/drinknuoro.com';a.target='_blank';a.rel='noopener'});
 const requestShop=()=>window.NuoroNavigation.goShop();
 d.querySelectorAll('a[href="#"],a[href="#shop"],a[href="#featured--product"]').forEach(a=>{
  if(/cta|btn/.test(a.className)||/essayer|commencer|découvrir|choisir|économisez|economisez/i.test(a.textContent))a.addEventListener('click',e=>{e.preventDefault();requestShop()});
  else if(/gérer mon abonnement/i.test(a.textContent)){a.href='https://drinknuoro.com/a/account/login';a.target='_top'}
  else if(/service client/i.test(a.textContent))a.href='/pages/assistance';
 });
 d.querySelectorAll('[aria-label="Mon compte"]').forEach(b=>b.addEventListener('click',()=>{window.location.href='https://drinknuoro.com/a/account/login'}));
 const burger=d.querySelector('.nuoro-mobile-toggle,.nav-burger'), nav=d.querySelector('.nav'), menu=d.querySelector('.nuoro-mobile-menu,.nav-menu');
 if(burger&&nav&&menu){
  menu.id='mobile-navigation';burger.setAttribute('aria-controls',menu.id);
  const sync=()=>{const open=nav.classList.contains('open');burger.setAttribute('aria-expanded',String(open));burger.setAttribute('aria-label',open?'Fermer le menu':'Ouvrir le menu');};sync();new MutationObserver(sync).observe(nav,{attributes:true,attributeFilter:['class']});
  const start=d.createElement('a');start.href='#shop';start.textContent='Choisir ma formule';start.addEventListener('click',e=>{e.preventDefault();nav.classList.remove('open');requestShop()});menu.append(start);
  d.addEventListener('keydown',e=>{if(e.key==='Escape'){nav.classList.remove('open');burger.focus();parent.postMessage({nuoroCloseCart:true},location.origin)}});
 }
 if(module==='Shop'){
  const sync=()=>d.querySelectorAll('.flavor,.qty-opt,.freq').forEach(b=>b.setAttribute('aria-pressed',String(b.classList.contains('active'))));sync();
  ['flavors','qty','freqs'].forEach(id=>{const el=d.getElementById(id);if(el)new MutationObserver(sync).observe(el,{subtree:true,attributes:true,attributeFilter:['class']})});
  d.querySelectorAll('.acc-head').forEach((b,i)=>{const answer=b.parentElement.querySelector('.acc-body');if(answer){answer.id='shop-answer-'+i;b.setAttribute('aria-controls',answer.id);const syncAcc=()=>{b.setAttribute('aria-expanded',String(b.parentElement.classList.contains('open')))};syncAcc();new MutationObserver(syncAcc).observe(b.parentElement,{attributes:true,attributeFilter:['class']})}});
 }
 if(mobile)d.querySelectorAll('.clin-t br,.freefrom__headline .claim br').forEach(br=>br.replaceWith(d.createTextNode(' ')));
 if(module==='Hero'){
  const cta=d.querySelector('a.cta');
  if(cta){const label=[...cta.childNodes].find(n=>n.nodeType===3&&/29%/.test(n.textContent));if(label){const original=label.textContent,phone=matchMedia('(max-width:767px)');const syncLabel=()=>{label.textContent=phone.matches?'−29% + cadeaux offerts ':original};syncLabel();phone.addEventListener('change',syncLabel)}}
 }
 if(mobile&&module==='Hero'){
  const fibreLabel=d.querySelector('.stat:nth-child(3) .lab');if(fibreLabel)fibreLabel.innerHTML='grammes<br>de fibres';

  const refund=d.querySelector('.reassure .item:not(.hero-delivery)');if(refund)refund.textContent='Remboursé à 100% jusqu’à 5 sticks testés';
  const delivery=d.querySelector('.hero-delivery');if(delivery)delivery.textContent='Livraison 48h';
  const qualities=d.querySelector('.hero-qualities');
  if(qualities){const items=qualities.textContent.split(' - ');qualities.replaceChildren(...items.map(text=>{const span=d.createElement('span');span.className='hero-quality';span.textContent=text.trim();return span}))}
 }
 if(mobile&&module==='Shop'){
  const support=d.querySelector('.shop__support p');if(support){const strong=d.createElement('strong');strong.textContent='Service client 7j/7';support.replaceChildren(strong)}
  const refund=d.querySelector('.post-cta .shop__refund strong');if(refund)refund.textContent='Remboursé à 100% jusqu’à 5 sticks testés';
  const terms=d.querySelector('.freq.best .fsub');
  if(terms){const delivery=terms.querySelector('[data-fsub-boxes]');if(delivery){const condition=d.createElement('span');condition.className='subscription-condition';condition.textContent=[...terms.childNodes].filter(n=>n!==delivery).map(n=>n.textContent).join('').replace(/^\s*·\s*/, '');terms.replaceChildren(delivery,d.createTextNode(" "),condition)}}
  const rail=d.querySelector('.prepare .steps');
  if(rail){
   const cards=[...rail.children], controls=d.createElement('div'), dots=d.createElement('div'), hint=d.createElement('p');
   rail.id='preparation-steps';rail.tabIndex=0;rail.setAttribute('role','region');rail.setAttribute('aria-label','Les trois étapes de préparation, faites glisser');
   controls.className='prepare-controls';dots.className='prepare-dots';dots.setAttribute('role','group');dots.setAttribute('aria-label','Choisir une étape');hint.className='prepare-hint';hint.textContent='Faites glisser pour découvrir';
   let current=0,queued=false;
   const select=i=>{current=i;[...dots.children].forEach((button,j)=>{if(i===j)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current')})};
   const go=i=>{i=Math.max(0,Math.min(cards.length-1,i));rail.scrollTo({left:cards[i].offsetLeft-cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
   cards.forEach((card,i)=>{
    card.setAttribute('role','group');card.setAttribute('aria-label','Étape '+(i+1)+' sur '+cards.length);
    const label=d.createElement('span');label.className='step-label';label.textContent='ÉTAPE '+(i+1);card.querySelector('p').before(label);
    const button=d.createElement('button');button.type='button';button.setAttribute('aria-label','Voir l’étape '+(i+1));button.setAttribute('aria-controls',rail.id);button.onclick=()=>go(i);dots.append(button);
   });
   select(0);controls.append(hint,dots);rail.after(controls);
   const syncStep=()=>{queued=false;const left=rail.getBoundingClientRect().left;let nearest=0,distance=Infinity;cards.forEach((card,i)=>{const delta=Math.abs(card.getBoundingClientRect().left-left);if(delta<distance){distance=delta;nearest=i}});if(rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2)nearest=cards.length-1;select(nearest)};
   rail.addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(syncStep)}},{passive:true});
   rail.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(current+(e.key==='ArrowRight'?1:-1))}else if(e.key==='Home'||e.key==='End'){e.preventDefault();go(e.key==='Home'?0:cards.length-1)}});
   new ResizeObserver(syncStep).observe(rail);
  }
 }
 if(mobile&&module==='Avis'){
  const rail=d.querySelector('.wall');if(rail){rail.tabIndex=0;rail.setAttribute('aria-label','Avis clients, défilement horizontal');
   const nav=d.createElement('div');nav.className='mobile-carousel-actions';nav.innerHTML='<button type="button" aria-label="Avis précédent">←</button><button type="button" aria-label="Avis suivant">→</button>';
   nav.children[0].onclick=()=>rail.scrollBy({left:-rail.clientWidth,behavior:'smooth'});nav.children[1].onclick=()=>rail.scrollBy({left:rail.clientWidth,behavior:'smooth'});rail.after(nav);
  }
 }
 if(module==='Comparateur'){
  const rail=d.querySelector('.comparison__scroll'),table=rail?.querySelector('table');
  if(table){
   const picker=d.createElement('label');picker.className='comparison-picker';
   const label=d.createElement('span');label.textContent='Comparer NUORO avec';
   const select=d.createElement('select');select.setAttribute('aria-label','Alternative à comparer avec NUORO');
   const products=[...table.querySelectorAll('thead th')];
   products.slice(2).forEach((cell,i)=>{const option=d.createElement('option');option.value=String(i+2);option.textContent=cell.querySelector('.comparison__name').textContent.trim();select.append(option)});
   picker.append(label,select);rail.before(picker);
   const choose=()=>{const selected=Number(select.value);[...table.querySelectorAll('tr')].forEach(row=>[...row.children].forEach((cell,i)=>cell.classList.toggle('comparison-alt-hidden',i>1&&i!==selected)));[...table.querySelectorAll('col')].forEach((col,i)=>col.classList.toggle('comparison-alt-hidden',i>1&&i!==selected));window.__nuoroFit?.()};
   select.addEventListener('change',choose);choose();
   const phone=matchMedia('(max-width:767px)');
   const sync=()=>{rail.tabIndex=phone.matches?-1:0;rail.setAttribute('aria-label',phone.matches?'Comparaison de NUORO avec l’alternative sélectionnée':'Tableau comparatif, défilement horizontal sur petit écran')};phone.addEventListener('change',sync);sync();
  }
 }
 d.querySelectorAll('img').forEach(img=>{img.decoding='async';if(module==='Hero')img.fetchPriority=img.closest('.dtc-pic')?'high':'auto';else if(!img.closest('.gal-main'))img.loading='lazy'});
 if(mobile&&module==='FAQ'){d.querySelectorAll('.acc-item.open').forEach(item=>{item.classList.remove('open');item.querySelector('.acc-head')?.setAttribute('aria-expanded','false')})}
 d.fonts.ready.then(()=>window.__nuoroFit?.());
})();

root.querySelectorAll("[data-nuoro-handler-0]").forEach(el=>el.addEventListener("click",function(event){event.stopPropagation()}));
root.querySelectorAll("[data-nuoro-handler-1]").forEach(el=>el.addEventListener("click",function(event){event.stopPropagation()}));
document.fonts.ready.then(()=>root.querySelectorAll("h1,h2,h3,h1 *,h2 *,h3 *").forEach(el=>{const c=getComputedStyle(el).color.match(/[\d.]+/g);if(c&&+c[0]>=200&&+c[1]>=80&&+c[1]<=210&&+c[2]<=160&&+c[0]>+c[1]*1.1)el.classList.add("nuoro-title-accent");}));
};
window.NuoroBoot("shop");


